import React from 'react'
import PropTypes from 'prop-types'

import ContentBlock from '../components/ContentBlock'

import localization from '../localization/surroundings'

import img_nature from '../assets/surroundings/nature.jpg'
import img_iceCaves from '../assets/surroundings/iceCaves.jpg'
import img_culture from '../assets/surroundings/culture.jpg'
import img_groceries from '../assets/surroundings/groceries.jpg'

const SurroundingsPage = (props) => {
  const { language } = props

  return (
    <React.Fragment>
      <ContentBlock darkBackground>
        <h1 className="t-heading-xl">{localization[language].title}</h1>
      </ContentBlock>

      <ContentBlock split>
        <div>
          <h2 className="t-heading-s">{localization[language].natureTitle}</h2>
          <p>{localization[language].natureP1}</p>
        </div>

        <div style={{ backgroundImage: `url(${img_nature})` }} />
      </ContentBlock>

      <ContentBlock split reverse>
        <div>
          <h2 className="t-heading-s">{localization[language].iceCavesTitle}</h2>
          <p>{localization[language].iceCavesP1}</p>
          <p>{localization[language].iceCavesP2}</p>
        </div>

        <div style={{ backgroundImage: `url(${img_iceCaves})` }} />
      </ContentBlock>

      <ContentBlock split>
        <div>
          <h2 className="t-heading-s">{localization[language].cultureTitle}</h2>
          <p>{localization[language].cultureP1}</p>
          <p>{localization[language].cultureP2}</p>
          <p>{localization[language].cultureP3}</p>
        </div>

        <div style={{ backgroundImage: `url(${img_culture})` }} />
      </ContentBlock>

      <ContentBlock split reverse darkBackground>
        <div>
          <h2 className="t-heading-s">{localization[language].groceriesTitle}</h2>
          <p>{localization[language].groceriesP1}</p>
        </div>

        <div style={{ backgroundImage: `url(${img_groceries})` }} />
      </ContentBlock>
    </React.Fragment>
  )
}

SurroundingsPage.propTypes = {
  language: PropTypes.string.isRequired,
}

export default SurroundingsPage



// WEBPACK FOOTER //
// ./src/pages/surroundings.js